import { connect } from 'react-redux';

import { Breadcrumbs, IBreadcrumbsStoreProps, IBreadcrumbsOwnProps } from './';
import { IState } from '../../store';

function mapStateToProps(state: IState): IBreadcrumbsStoreProps {
  return {
    breadcrumbs: state.villageData.breadcrumbs ?? [],
  };
}

export const BreadcrumbsContainer = connect<IBreadcrumbsStoreProps, {}, IBreadcrumbsOwnProps>(mapStateToProps)(
  Breadcrumbs,
);
